module.exports = __webpack_public_path__ + "static/3-75ce43302041e5b31693c143a0e0ab75.jpg";